import styled from 'styled-components';
import List from '@mui/material/List';

/**
 * Reproduces the previous `collapseCardStyles` (makeStyles) overrides that were
 * passed to CollapseCard via `customClasses`, using descendant selectors on the
 * list wrapping each CollapseCard.
 */
const StyledCollapseList = styled(List)`
  && > div {
    margin-top: 0;
    margin-bottom: 16px;
  }

  && > div > button {
    background-color: #fbfbfb;
    border: 1px solid #eeeeee;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
    color: #4d4f5c;
    padding: 6px 24px;
    text-transform: capitalize;
    font-size: 13px;
  }

  && > div > button:hover {
    background-color: #fbfbfb;
    border: 1px solid #eeeeee;
    box-shadow: none;
    color: #4d4f5c;
  }

  && .MuiCollapse-wrapperInner > div {
    margin-top: 0;
    border-top: 0;
    border-radius: 0 0 4px 4px;
    padding: 16px 24px;
  }
`;

export { StyledCollapseList };
